import React, { useEffect, useState } from "react";
import "./AboutPage.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import { getData } from "../features/dataSlice";
import { css } from "@emotion/core";
import RingLoader from "react-spinners/RingLoader";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";
import { IconButton } from "@material-ui/core";

const override = css`
  display: block;
  margin: auto;
  margin-left: -10%;
  border-color: red;
`;

const AboutPage = () => {
  const data = useSelector(getData);

  const [expanded, setExpanded] = useState(data?.about.intro.heading);

  useEffect(() => {
    document.title = "Ashwin's Portfolio - About";
    return () => {
      //
    };
  }, []);

  const handleChange = (content) => {
    if (content !== expanded) {
      setExpanded(content);
    } else if (content === expanded) {
      setExpanded("");
    }
  };

  return (
    <div className="about">
      <Header />
      {data !== null ? (
        <div className="about-body">
          <div className="accordian">
            <h3 onClick={() => handleChange(data.about.intro.heading)}>
              {data.about.intro.heading}{" "}
              {data.about.intro.heading !== expanded ? (
                <IconButton>
                  <ExpandMoreRoundedIcon />
                </IconButton>
              ) : (
                <IconButton>
                  <ExpandLessRoundedIcon />
                </IconButton>
              )}
            </h3>
            {expanded === data.about.intro.heading && (
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {data.about.intro.lineOne} <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {data.about.intro.lineTwo}
              </p>
            )}

            <h3 onClick={() => handleChange(data.about.education.heading)}>
              {data.about.education.heading}{" "}
              {data.about.education.heading !== expanded ? (
                <IconButton>
                  <ExpandMoreRoundedIcon />
                </IconButton>
              ) : (
                <IconButton>
                  <ExpandLessRoundedIcon />
                </IconButton>
              )}
            </h3>
            {expanded === data.about.education.heading && (
              <ul>
                <li>{data.about.education.institution}</li>
                <li>{data.about.education.location}</li>
                <li>{data.about.education.type}</li>
                <li>{data.about.education.major}</li>
              </ul>
            )}

            <h3 onClick={() => handleChange("skills")}>
              Skills{" "}
              {"skills" !== expanded ? (
                <IconButton>
                  <ExpandMoreRoundedIcon />
                </IconButton>
              ) : (
                <IconButton>
                  <ExpandLessRoundedIcon />
                </IconButton>
              )}
            </h3>
            {expanded === "skills" && (
              <>
                {data.about.skills.map((skill, i) => (
                  <div className="sub-accordian" key={i}>
                    <h4 className="sub-header">{skill.name}</h4>
                    <ul className="skill-images">
                      {skill.images.map((image, j) => (
                        <li key={j}>
                          <img loading="lazy" src={image} alt="" />
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </>
            )}

            <h3 onClick={() => handleChange("awards")}>
              Awards{" "}
              {"awards" !== expanded ? (
                <IconButton>
                  <ExpandMoreRoundedIcon />
                </IconButton>
              ) : (
                <IconButton>
                  <ExpandLessRoundedIcon />
                </IconButton>
              )}
            </h3>
            {expanded === "awards" && (
              <>
                {data.about.awards.map((award, i) => (
                  <div className="sub-accordian" key={i}>
                    <h4 className="sub-header">{award.name}</h4>
                    <ul>
                      {award.points.map((point, j) => (
                        <li key={j}>{point}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="sweet-loading">
          <RingLoader
            color={"#17D0D3"}
            loading={data === null}
            css={override}
            size={150}
          />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default AboutPage;
